import React from 'react';
import { useTranslations } from 'next-intl';
import type { AgeCategoryEntry } from './types';
import styles from './AgeCategoryRow.module.css';

type AgeCategoryRowProps = {
  entry: AgeCategoryEntry;
};

export const AgeCategoryRow: React.FC<AgeCategoryRowProps> = ({ entry }) => {
  const t = useTranslations('performance-lab');
  const empty = t('leaderboard.emptyValue');
  const displayName = entry.name ?? empty;
  const displayScore =
    entry.score != null ? entry.score.toFixed(1) : empty;

  return (
    <li className={styles.row}>
      <div className={styles.nameLine}>
        <span className={styles.name}>{displayName}</span>
        {entry.tag != null ? (
          <>
            <span className={styles.tagSeparator} aria-hidden="true">/</span>
            <span className={styles.nameTagSuffix}>{entry.tag}</span>
          </>
        ) : null}
      </div>
      <span className={styles.score}>{displayScore}</span>
    </li>
  );
};
